import React from 'react'

const DistancePointIcon = () => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_14078_71116)'>
				<path
					d='M7.99935 1.33594C5.05383 1.33594 2.66602 3.72375 2.66602 6.66927C2.66602 10.8159 6.03268 10.7826 6.83935 13.1893L7.17935 14.2159C7.27468 14.4995 7.54725 14.6849 7.84601 14.6693H8.21935C8.51811 14.6849 8.79068 14.4995 8.88601 14.2159L9.22601 13.1893C9.99935 10.7826 13.3327 10.8159 13.3327 6.66927C13.3327 3.72375 10.9449 1.33594 7.99935 1.33594ZM7.99935 8.66927C6.89478 8.66927 5.99935 7.77384 5.99935 6.66927C5.99935 5.5647 6.89478 4.66927 7.99935 4.66927C9.10392 4.66927 9.99935 5.5647 9.99935 6.66927C9.99935 7.1997 9.78863 7.70841 9.41356 8.08348C9.03849 8.45856 8.52978 8.66927 7.99935 8.66927Z'
					fill='#808080'
				/>
			</g>
			<defs>
				<clipPath id='clip0_14078_71116'>
					<rect width='16' height='16' fill='white' />
				</clipPath>
			</defs>
		</svg>
	)
}

export default DistancePointIcon
